import React from "react";
import { TemplateNineResumeSection } from "./common";
import { View } from "@react-pdf/renderer";
import { ResumePDFText } from "../ResumePDF/common";

const Summary = ({
  heading,
  summary,
  themeColor,
}: {
  heading: string;
  summary: string;
  themeColor: string;
}) => {
  return (
    <TemplateNineResumeSection themeColor={themeColor} heading={heading}>
      <View>
        {summary && <ResumePDFText>{summary}</ResumePDFText>}
      </View>
    </TemplateNineResumeSection>
  );
};

export default Summary;
